"use client";
import React, { useRef, useMemo } from "react";
import log from "logbeacon";
import { SvgXmlProps } from "./types";

const SvgXml: React.FC<SvgXmlProps> = ({
  xml,
  fill,
  width,
  height,
  size,
  className,
  ...props
}) => {
  const divRef = useRef<HTMLDivElement | null>(null);
  const svgWidth = useMemo(() => {
    if (size) {
      return size;
    }
    return width;
  }, [size, width]);

  const svgHeight = useMemo(() => {
    if (size) {
      return size;
    }
    return height;
  }, [size, height]);
  const processedXml = useMemo(() => {
    let updatedXml = xml;

    // Remove width and height attributes from the SVG string
    if (svgWidth) {
      updatedXml = updatedXml.replace(/width="[^"]*"/, "");
    }
    if (svgHeight) {
      updatedXml = updatedXml.replace(/height="[^"]*"/, "");
    }
    // Replace fill in the XML string
    if (fill) {
      updatedXml = updatedXml.replace(/fill="[^"]*"/g, `fill="${fill}"`);
      if(updatedXml.includes("fill_fixed")) {
        log.debug("[文案]fill_fixed", updatedXml);
        updatedXml = updatedXml.replace(/fill_fixed/, `fill`);
      }

      
    }


    return updatedXml;
  }, [xml, fill, svgHeight, svgWidth]);

  const divProps = {
    dangerouslySetInnerHTML: {
      __html: processedXml,
    },
    style: {
      height: svgHeight ? `${svgHeight}px` : undefined,
      width: svgWidth ? `${svgWidth}px` : undefined,
    },
  };

  return (
    <div {...props} className={className}>
      <div
        ref={divRef}
        {...divProps}
        style={{ pointerEvents: "none", ...divProps.style }}
      />
    </div>
  );
};

export { SvgXml };
